export const DRIVER_NAMES: Record<number, string> = {
  1: 'Performance Unità Reclami BDT',
  2: 'Filiali a Premio',
  3: 'Ricavi',
  4: 'Focus Picchi Ricavi',
  5: 'Focus KPI, Eccellenza di Filiale ed Eccellenza Operativa',
  6: "Correlazione con l'Indicatore di Conformità",
  7: 'Gestori Global Advisor',
  8: 'Focus Aree',
  9: 'Fruizione della Formazione',
  // Investigation drivers (10+): analisi manuali della Compliance,
  // non partecipano alla generazione del report.
  10: 'Salto di Fasce',
  11: 'Incremento Commissioni Nette Q4 Quota C',
  12: 'Outlier con Clustering Filiali',
  13: 'Estensione Analisi Picchi Ricavi',
  14: 'Incremento Flusso Netto di Risparmio Gestito a Dicembre',
  15: 'Decremento Flusso Netto a Dicembre con Incremento a Gennaio',
};

/** Numero da cui iniziano i driver di Investigation (non usati per il report). */
export const INVESTIGATION_DRIVER_MIN = 10;

/** Slug e nome della sezione "Aggregazione Evidenze Investigation".
 *  Non e' un driver: e' una tabella di riepilogo servita da un endpoint
 *  dedicato, ma viene mostrata in una pagina come i driver di Investigation. */
export const INVESTIGATION_SUMMARY_SLUG = 'aggregazione-evidenze-investigation';
export const INVESTIGATION_SUMMARY_NAME = 'Aggregazione Evidenze Investigation';

/** True se il driver appartiene alla sezione "Investigation" (Driver 10+). */
export const isInvestigationDriver = (driverNumber: number): boolean =>
  driverNumber >= INVESTIGATION_DRIVER_MIN;

const slugify = (s: string): string =>
  s
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const DRIVER_SLUGS: Record<number, string> = Object.fromEntries(
  Object.entries(DRIVER_NAMES).map(([n, name]) => [Number(n), slugify(name)]),
);

export const driverNumberToSlug = (n: number): string => DRIVER_SLUGS[n] ?? String(n);

export const slugToDriverNumber = (slug: string): number | null => {
  const entry = Object.entries(DRIVER_SLUGS).find(([, s]) => s === slug);
  return entry ? Number(entry[0]) : null;
};

/** Estrae il numero dal kind del componente (es. "Driver01" -> 1, "Driver10" -> 10). */
export const driverNumberFromKind = (kind: string): number | null => {
  const m = /^Driver(\d{2,})$/.exec(kind);
  return m ? parseInt(m[1], 10) : null;
};

/** True se il kind identifica un Annex (es. "Annex52"). Gli Annex compaiono
 *  nella lista driver come card di sola consultazione (non cliccabili). */
export const isAnnexKind = (kind: string): boolean => /^Annex\d+$/.test(kind);
